import type { RegisteredComponent } from '@builder.io/sdk-vue'

import BaseAccordionMenuLinks__Builder from '~/components/BaseAccordionMenuLinks__Builder'
import BaseBoosterYouTube__Builder from '~/components/BaseBoosterYouTube__Builder'

export const CommonComponents: RegisteredComponent[] = [
  BaseAccordionMenuLinks__Builder,
  BaseBoosterYouTube__Builder,
]
